import * as React from 'react';
import { Box, Grid, Typography, Pagination, CircularProgress, Stack } from '@mui/material';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import { TextField } from 'react-admin';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react'
import MoleculeStructure from '../MoleculeStructure';

const TransformerVaeProtein2LigandOutputShow = ({ data, isLoading, error }) => {
    const [idx, setIdx] = useState(0);
    const minHeight = 250

    if (error) {
        return (
            <Grid container direction="column" alignItems="center" minHeight={minHeight} justifyContent="center">
                <Grid item>
                    <ErrorIcon sx={{ color: 'red', fontSize: 60 }} />
                </Grid>
                <Grid item>
                    Data Loading Error!
                </Grid>
            </Grid>
        )
    }

    if (isLoading || !data?.outputData) {
        return (
            <Grid container direction="column" alignItems="center" minHeight={minHeight} justifyContent="center">
                <Grid item>
                    <CircularProgress size={50} />
                </Grid>
            </Grid>
        )
    }

    try {
        const { outputData } = data;
        const { ligandList } = outputData;
        let reconstructionParameterDataKeys = [];
        let reconstructionParameterData = ligandList.map(
            (ligand, ligandIdx) => {
                if (ligand.reconstructionParameter) {
                    const keys = Object.keys(ligand.reconstructionParameter);
                    reconstructionParameterDataKeys.push(...keys);
                    return { id: ligandIdx + 1, ...ligand.reconstructionParameter };
                }
                return { id: ligandIdx + 1 };
            })
        reconstructionParameterDataKeys = Array.from(new Set(reconstructionParameterDataKeys))
        const f = Object.fromEntries(reconstructionParameterDataKeys.map((e) => [e, '-']))
        reconstructionParameterData = reconstructionParameterData.map(
            (e) => {
                return { ...f, ...e };
            }
        )

        return (
            <Stack>
                <Grid container spacing={2} minHeight={minHeight}>
                    <Grid item xs={5} alignItems="center">
                        <Stack justifyContent="center" alignItems="center">
                            <Typography variant="h6" gutterBottom>
                                Ligand Reconstruction
                            </Typography>
                            <MoleculeStructure id={ligandList[idx].reconstructionSmiles} structure={ligandList[idx].reconstructionSmiles}
                                height={150} width={350} svgMode
                            />
                            <Typography sx={{ wordBreak: 'break-all' }} variant="root" width={400} align="center">
                                {ligandList[idx].reconstructionSmiles}
                            </Typography>
                        </Stack>
                    </Grid>

                    <Grid item xs={7} alignItems="center">
                        <Stack justifyContent="center" alignItems="center">
                            <Typography variant="h6" gutterBottom>
                                Ligand Fragments
                            </Typography>

                            <Box pt="3em" />

                            <Stack direction="row" spacing={0} maxWidth={800} sx={{ overflowX: 'auto' }}>
                                {ligandList[idx].fragmentSmilesList.map((fragmentSmiles, fragmentSmilesIdx) => (
                                    <Stack justifyContent="center" alignItems="center" key={'stack_' + fragmentSmilesIdx + fragmentSmiles}>
                                        <MoleculeStructure id={fragmentSmiles} structure={fragmentSmiles}
                                            height={75} width={150} svgMode
                                        />
                                        <Box pt="1em" />
                                        <Typography sx={{ wordBreak: 'break-all' }} variant="root" align="center">
                                            {fragmentSmiles}
                                        </Typography>
                                        <Box pt="1em" />
                                    </Stack>
                                ))}
                            </Stack>
                        </Stack>
                    </Grid>
                </Grid>

                <Grid container justifyContent="center">
                    <Pagination count={ligandList.length} size="small" onChange={(event, page) => setIdx(page - 1)} />
                </Grid>

                <Box pt="1em" />

                {/* Deprecated (Maybe attribute conflict) */}
                {/* <Datagrid data={reconstructionParameterData} total={ligandList.length} bulkActionButtons={false}>
                    <TextField source="id" label="No." />
                    {getTextFields(reconstructionParameterDataKeys)}
                </Datagrid> */}

                <Box>
                    <DataGrid
                        rows={reconstructionParameterData}
                        columns={[
                            {field: 'id', headerName: 'No.'}, 
                            ...reconstructionParameterDataKeys.map((e) => ({ field: e }))
                        ]}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        checkboxSelection
                        autoHeight={true}
                    />
                </Box>

            </Stack>
        );

    } catch (error) {
        console.error(error);
        return (
            <Grid container direction="column" alignItems="center" minHeight={minHeight} justifyContent="center">
                <Grid item>
                    <ErrorIcon sx={{ color: 'red', fontSize: 60 }} />
                </Grid>
                <Grid item>
                    Data Parsing Error!
                </Grid>
            </Grid>
        )
    }

};

// Deprecated
// eslint-disable-next-line no-unused-vars
const getTextFields = (keys) => (
    keys.map(key => <TextField key={`field_${key}`} source={key} />)
)

export default TransformerVaeProtein2LigandOutputShow;
